export default {
  app: 'APP_BCG',
  api: 'https://www.researchfollowapp.com/portal'
};
